var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFilledTickGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#196323"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.162 21.322c-.432 0-.844-.175-1.14-.485L.424 12.862c-.592-.619-.56-1.593.069-2.175.63-.583 1.619-.552 2.208.067l6.445 6.762 13.137-14.17c.585-.63 1.572-.671 2.21-.099.636.573.68 1.548.098 2.175L10.315 20.82c-.293.318-.708.5-1.143.502h-.01z",
    transform: "translate(-765 -1280) translate(765 1280)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilledTickGreen);
export default __webpack_public_path__ + "static/media/icon-filled-tick-green.0313d06c09a5c3791f0644c9d1603fa4.svg";
export { ForwardRef as ReactComponent };